import * as React from 'react';
import { connect } from 'react-redux';

// Global Types
import { EntityEntityTypeId } from 'services/entities/types';

// Global Actions
// @ts-ignore
import { resetSelectedTableCells } from 'services/selectedTableCells/actions';

interface OwnProps {
    entityTypeId?: EntityEntityTypeId;
}

interface DispatchProps {
    resetSelectedTableCells: Function;
}

type Props = OwnProps & DispatchProps;

export class ResetSelectedTableCellsOnEntityTypeUpdateComponent extends React.PureComponent<
    Props
> {
    componentDidUpdate(prevProps: Props): void {
        const { props } = this;

        if (props.entityTypeId !== prevProps.entityTypeId) {
            props.resetSelectedTableCells();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.resetSelectedTableCells();
    }

    render(): null {
        return null;
    }
}

export default connect(
    null,
    {
        resetSelectedTableCells
    }
)(ResetSelectedTableCellsOnEntityTypeUpdateComponent);
